.match {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  /* Measured by its own width, so a narrowed table column can drop the figure (below). */
  container-type: inline-size;
}

/* **The figure goes rather than truncates.** "100%" cut to "1…" reads as 1, so once the bar is at
   its minimum and the full figure no longer fits beside it, the figure is hidden and the bar takes
   the column; the value stays on hover (`title`). */
@container (max-width: 92px) {
  .value {
    display: none;
  }
}

/* In a narrow column the bar gives way first, down to `min-width`; below that the figure beside it
   is dropped (the container query above) and the bar takes the column again. */
.track {
  flex: 1 1 0;
  min-width: 24px;
  height: 4px;
  border-radius: 4px;
  background: var(--c-border);
  overflow: hidden;
}

.lg .track {
  height: 6px;
}

.fill {
  height: 100%;
  border-radius: 4px;
  background: linear-gradient(90deg, var(--c-brand-vivid), var(--c-brand), var(--c-brand-blue));
}

.dimFill {
  background: linear-gradient(90deg, var(--c-brand-deep), var(--c-brand-blue));
}

.fullFill {
  background: linear-gradient(90deg, var(--c-brand-vivid), var(--c-brand), var(--c-brand-light));
  box-shadow: 0 0 10px var(--glow);
}

.value {
  flex: 0 0 48px;
  white-space: nowrap;
  text-align: right;
  font-family: var(--font-mono);
  font-weight: 600;
  font-size: var(--text-subtitle);
  color: var(--c-text-primary);
  font-variant-numeric: tabular-nums;
}

.sm .value {
  font-size: var(--text-caption);
  flex-basis: 40px;
}

.lg .value {
  font-size: var(--text-headline);
  flex-basis: 60px;
}

.fullValue {
  color: var(--c-brand-muted);
}

.unknown {
  color: var(--c-text-tertiary);
}

.bar {
  border-radius: 6px;
  background: var(--c-border);
  overflow: hidden;
  min-width: 20px;
}

.barFill {
  height: 100%;
  border-radius: 6px;
}

.tone_brand {
  background: var(--c-brand);
}

.tone_warn {
  background: var(--c-warning);
}

.tone_neg {
  background: var(--c-negative);
}

.tone_pos {
  background: var(--c-positive);
}

.tone_muted {
  background: var(--c-text-tertiary);
}
